<section class="services-section" id="services">
  <div class="container">

    <h2 class="services-heading">
      {{'GB_Registration_Services' | translate}}
    </h2>

    <div class="services-grid">
      <div class="service-card" *ngFor="let item of services">

        <div class="card-image">
          <img [src]="item.sm" [alt]="item.title | translate" />
          <span class="card-icon-badge">
            <i class="{{item.icon}}"></i>
          </span>
        </div>

        <div class="card-body">
          <a [routerLink]="['/pages/services/' + item.id]" class="card-title">
            {{item.title | translate}}
          </a>
          <p class="card-desc" [innerHTML]="item.description | translate"></p>
          <a [routerLink]="['/pages/services/' + item.id]" class="card-readmore">
            {{item.iconText | translate}}
            <i class="fa-solid fa-arrow-right"></i>
          </a>
        </div>

      </div>
    </div>

  </div>
</section>
